// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1V2E_","label":"CategoryService_label__OCPgT","location":"CategoryService_location__1lUS2"};